import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import useHCPContext from '../context/useHCPContext';

function Table() {
  const { loading, hcpData, handleHCPExport, totalUnassigned } = useContext(useHCPContext);

  const handlePercentCellClassName = (manager, value) => {
    let className;

    if (parseFloat(value) >= 101 && manager !== 'Total') {
      className = 'cell-super-green';
    }

    if (parseFloat(value) >= 90 && parseFloat(value) <= 100 && manager !== 'Total') {
      className = 'cell-green';
    }

    if (parseFloat(value) >= 85 && parseFloat(value) <= 89 && manager !== 'Total') {
      className = 'cell-yellow';
    }

    if (parseFloat(value) < 85 && manager !== 'Total') {
      className = 'cell-red';
    }

    return className;
  };

  const callReachFields = [
    {
      field: 'call_reach_protect_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_protect_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_protect_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_protect_percent),
    },
    //
    {
      field: 'call_reach_develop_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_develop_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_develop_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_develop_percent),
    },
    //

    {
      field: 'call_reach_gain_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_gain_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_gain_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_gain_percent),
    },
    //
    {
      field: 'call_reach_total_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_total_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_total_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_total_percent),
    },
  ];

  const callVolumeFields = [
    {
      field: 'call_volume_protect_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_protect_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_protect_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_volume_protect_percent),
    },
    //
    {
      field: 'call_volume_develop_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_develop_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_develop_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_volume_develop_percent),
    },
    //

    {
      field: 'call_volume_gain_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_gain_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_gain_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_volume_gain_percent),
    },
    //
    {
      field: 'call_volume_total_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_total_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_total_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-volume-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_volume_total_percent),
    },
  ];

  const callConcentrationFields = [
    {
      field: 'call_concentration_protect_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_protect_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_protect_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_concentration_protect_percent),
    },
    //
    {
      field: 'call_concentration_develop_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_develop_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_develop_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_concentration_develop_percent),
    },
    //

    {
      field: 'call_concentration_gain_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_gain_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_gain_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_concentration_gain_percent),
    },
    //
    {
      field: 'call_concentration_total_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_total_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_concentration_total_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-concentration-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_concentration_total_percent),
    },
  ];

  const columns = [
    {
      field: 'manager',
      sortable: false,
      headerName: 'HTAM Name',
      width: 200,
      renderCell: ({ row }) => `${row.manager === 'Total' ? '' : row.manager}`,
    },

    {
      field: 'rep_name',
      sortable: false,
      headerName: 'HTAR Name',
      width: 200,
    },
    ...callReachFields,
    ...callVolumeFields,
    ...callConcentrationFields,
  ];

  const columnGroupingModel = [
    {
      groupId: 'total_unassigned',
      headerName: `Total Unassigned: ${totalUnassigned}`,
      headerAlign: 'right',
      align: 'right',
      headerClassName: 'call-header-reach-theme-style-total',
      children: [
        {
          groupId: 'call_reach',
          headerName: 'Call Reach',
          headerAlign: 'center',
          align: 'center',
          headerClassName: 'call-reach-theme-style',
          children: [
            {
              groupId: 'call_reach_protect',
              headerName: 'Protect',
              headerAlign: 'center',
              headerClassName: 'call-reach-theme-style',
              children: [
                { field: 'call_reach_protect_t' },
                { field: 'call_reach_protect_a' },
                { field: 'call_reach_protect_percent' },
              ],
            },
            {
              groupId: 'call_reach_develop',
              headerName: 'Develop',
              headerAlign: 'center',
              headerClassName: 'call-reach-theme-style',
              children: [
                { field: 'call_reach_develop_t' },
                { field: 'call_reach_develop_a' },
                { field: 'call_reach_develop_percent' },
              ],
            },
            {
              groupId: 'call_reach_gain',
              headerName: 'Gain',
              headerAlign: 'center',
              headerClassName: 'call-reach-theme-style',
              children: [
                { field: 'call_reach_gain_t' },
                { field: 'call_reach_gain_a' },
                { field: 'call_reach_gain_percent' },
              ],
            },
            {
              groupId: 'total_call_reach',
              headerName: 'Total Call Reach',
              headerAlign: 'center',
              headerClassName: 'call-reach-theme-style',
              children: [
                { field: 'call_reach_total_t' },
                { field: 'call_reach_total_a' },
                { field: 'call_reach_total_percent' },
              ],
            },
          ],
        },
        {
          groupId: 'call_volume',
          headerName: 'Call Volume',
          headerAlign: 'center',
          headerClassName: 'call-volume-theme-style',
          children: [
            {
              groupId: 'protect',
              headerName: 'Protect',
              headerAlign: 'center',
              headerClassName: 'call-volume-theme-style',
              children: [
                { field: 'call_volume_protect_t' },
                { field: 'call_volume_protect_a' },
                { field: 'call_volume_protect_percent' },
              ],
            },
            {
              groupId: 'develop',
              headerName: 'Develop',
              headerAlign: 'center',
              headerClassName: 'call-volume-theme-style',
              children: [
                { field: 'call_volume_develop_t' },
                { field: 'call_volume_develop_a' },
                { field: 'call_volume_develop_percent' },
              ],
            },
            {
              groupId: 'gain',
              headerName: 'Gain',
              headerAlign: 'center',
              headerClassName: 'call-volume-theme-style',
              children: [
                { field: 'call_volume_gain_t' },
                { field: 'call_volume_gain_a' },
                { field: 'call_volume_gain_percent' },
              ],
            },
            {
              groupId: 'total_call_volume',
              headerName: 'Total Call Volume',
              headerAlign: 'center',
              headerClassName: 'call-volume-theme-style',
              children: [
                { field: 'call_volume_total_t' },
                { field: 'call_volume_total_a' },
                { field: 'call_volume_total_percent' },
              ],
            },
          ],
        },
        {
          groupId: 'call_concentration',
          headerName: 'Call Concentration',
          headerAlign: 'center',
          headerClassName: 'call-concentration-theme-style',
          children: [
            {
              groupId: 'call_concentration_protect',
              headerName: 'Protect',
              headerAlign: 'center',
              headerClassName: 'call-concentration-theme-style',
              children: [
                { field: 'call_concentration_protect_t' },
                { field: 'call_concentration_protect_a' },
                { field: 'call_concentration_protect_percent' },
              ],
            },
            {
              groupId: 'call_concentration_develop',
              headerName: 'Develop',
              headerAlign: 'center',
              headerClassName: 'call-concentration-theme-style',
              children: [
                { field: 'call_concentration_develop_t' },
                { field: 'call_concentration_develop_a' },
                { field: 'call_concentration_develop_percent' },
              ],
            },
            {
              groupId: 'call_concentration_gain',
              headerName: 'Gain',
              headerAlign: 'center',
              headerClassName: 'call-concentration-theme-style',
              children: [
                { field: 'call_concentration_gain_t' },
                { field: 'call_concentration_gain_a' },
                { field: 'call_concentration_gain_percent' },
              ],
            },
            {
              groupId: 'total_call_concentration',
              headerName: 'Total Call Concentration',
              headerAlign: 'center',
              headerClassName: 'call-concentration-theme-style',
              children: [
                { field: 'call_concentration_total_t' },
                { field: 'call_concentration_total_a' },
                { field: 'call_concentration_total_percent' },
              ],
            },
          ],
        },
      ],
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            color='warning'
            onClick={handleHCPExport}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export HCP
          </Button>
        </Box>
        <Box
          className='table-container'
          sx={{
            height: '1000px',
            marginLeft: '20px',
            '& .call-header-reach-theme-style-total .MuiDataGrid-columnHeaderTitle': {
              color: '#DC143C',
              fontWeight: 'bold',
            },
            '& .call-reach-theme-style': {
              backgroundColor: '#DCDCDC',
              border: '1px solid #C0C0C0',
            },
            '& .total-row': {
              backgroundColor: '#f0ad4e',
              color: '#000',
              fontWeight: '600',
            },
            '& .call-reach-theme-style div .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#000',
            },

            '& .call-volume-theme-style': {
              backgroundColor: '#A9A9A9',
              border: '1px solid #DCDCDC',
            },

            '& .call-volume-theme-style div .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#000',
            },

            '& .call-concentration-theme-style': {
              backgroundColor: '#696969',
              border: '1px solid #A9A9A9',
            },

            '& .call-concentration-theme-style div .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#fff',
            },
            '& .cell-green': {
              backgroundColor: '#ACE1AF',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-yellow': {
              backgroundColor: '#f0ad4e',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-red': {
              backgroundColor: '#FFADB0',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-super-green': {
              backgroundColor: '#5cb85c',
              color: '#000',
              fontWeight: '600',
            },

            '& .MuiDataGrid-row': {
              pointerEvents: 'none',
            },
          }}
        >
          <DataGridPro
            // treeData
            loading={loading}
            rows={hcpData}
            columns={columns}
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{ columnGrouping: true }}
            getRowClassName={(params) => (params.row.manager === 'Total' ? 'total-row' : '')}
            // getTreeDataPath={getTreeDataPath}
            // groupingColDef={groupingColDef}
            // pinnedRows={pinnedRows}
            // experimentalFeatures={{ rowPinning: true }}
            initialState={{ pinnedColumns: { left: ['manager', 'rep_name'] } }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default Table;
